import React from "react";

const SvgPlay = props => <svg width={63} height={79} viewBox="0 0 63 79" fill="none" {...props}><path d="M0 0V79L63 39.5L0 0Z" fill="white" /></svg>;

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjMiIGhlaWdodD0iNzkiIHZpZXdCb3g9IjAgMCA2MyA3OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMFY3OUw2MyAzOS41TDAgMFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgPlay as ReactComponent };